const isSlotEditable = (slot, options = {}) => {
    if (slot.editable === false)
        return false
    if (options.needsManageable)
        return slot.manageable
    if (options.needsSelectable)
        return slot.selectable
    return true
}

const validationColoring = (slot, validationResults = {}) => {
    return validationResults[slot.id] || 'success';
}

const standardColoring = (slot, slotOptions, current) => {
    let cssClass = slot.sort_key === current ? 'active ' : ''
    if (!isSlotEditable(slot, slotOptions))
        return cssClass + 'readonly'
    return cssClass + (slot.content ? 'filled ' : 'empty ')
}

function getSlotContent(data, showContent = true) {
    return data.content ? data.content : "Empty"
}

function getSlotTitle(data) {
    if (data.action) {
        const Messages = {
            delete: 'Delete Slot',
            create: 'Create Slot After',
        };
        return `${Messages[data.action]} ${data.title}`
    }
    return data.title
}

export {
    isSlotEditable,
    validationColoring,
    standardColoring,
    getSlotContent,
    getSlotTitle
}